import React from 'react';
import { Form, Select, Tag, Tooltip } from 'antd';
import type { SelectProps } from 'antd';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { colorConfigs } from '../../../config/commonConfig';
import { renderExtraTags } from '../utility';

interface ICustomSelectInputProps {
  options: SelectProps['options'] | null;
  name: string | (string | number)[];
  label?: string;
  placeholder: string;
  tagColor?: string;
  mode?: 'multiple' | 'tags';
  showArrow?: boolean;
  required?: boolean;
  className?: string;
  responsive?: boolean;
}

const tagRender = (props: CustomTagProps, color?: string) => {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={color ?? colorConfigs.DEFAULT_TAG_COLOR}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginRight: 3 }}
    >
      {(label??'').toString()?.length > 25 ? <Tooltip title={label} trigger={["hover", "focus"]}>{`${label?.toString()?.slice(0,25)}...`}</Tooltip> : label}
    </Tag>
  );
};

const CustomSelectInput: React.FC<ICustomSelectInputProps> = ({
  options,
  name,
  label,
  placeholder,
  tagColor,
  mode = 'multiple',
  showArrow = true,
  required = false,
  className = '',
  responsive = false,
}) => {
  return (
    <Form.Item name={name} label={label} required={required} rules={[{required:required, message:`${label} is required`}]}>
      <Select
        className={className??null}
        showSearch
        mode={mode}
        filterOption={(input, option) =>
          (option?.titleLabelText ?? "")
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        tagRender={(props) => tagRender(props, tagColor)}
        maxTagCount={ responsive ? "responsive" : undefined}
        maxTagPlaceholder={(omittedValues) => {
          if(omittedValues.length > 0){
            let stringValues = omittedValues.map( each => each.label?.toString() as string )
            return renderExtraTags(stringValues)
          }
        }}
        placeholder={placeholder}
        showArrow={!options || showArrow}
        loading={!options}
        aria-label={label}
        title={label??undefined}
        notFoundContent={mode === 'multiple' && null}
        optionFilterProp='label'
        options={(options ?? []).map((d) => ({
          value: d.value,
          label: d.label,
          titleLabelText: `${d.label}`
        }))}
      />
    </Form.Item>
  );
};

export default CustomSelectInput;
